import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import WebViewBridge from "../webViewBridge";

export async function printOrderTicket(element: HTMLElement): Promise<void> {
  if (document.fonts?.ready) {
    await document.fonts.ready;
  }
  const canvas = await html2canvas(element, {
    backgroundColor: "#ffffff",
    scale: 2,
    useCORS: true,
  });
  const dataUrl = canvas.toDataURL("image/png");
  const bridge = WebViewBridge.getInstance();

  if (bridge.isReactNative()) {
    await bridge.printReceipt(dataUrl);
    return;
  }

  const w = Math.ceil(canvas.width / 3.77952755905511);
  const h = Math.ceil(canvas.height / 3.77952755905511);
  const pdf = new jsPDF("p", "mm", [w, h]);
  const width = pdf.internal.pageSize.getWidth();
  const height = pdf.internal.pageSize.getHeight();
  pdf.addImage(dataUrl, "PNG", 0, 0, width, height);
  pdf.save(`purple__${new Date().toISOString()}.pdf`);
}
